import { useEffect } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { AppErrorBoundary } from "./AppErrorBoundary";
import { WorkspaceLayout } from "./WorkspaceLayout";
import { setSpaNavigate } from "./spaNavigationBridge";
import { LandingRoute } from "./routes/LandingRoute";
import { DashboardRoute } from "./routes/DashboardRoute";
import { LoginRoute } from "./routes/LoginRoute";
import { ProjectsRoute } from "./routes/ProjectsRoute";
import { NewProjectRoute } from "./routes/NewProjectRoute";
import { ProjectDetailRoute } from "./routes/ProjectDetailRoute";
import { ProjectSettingsRoute } from "./routes/ProjectSettingsRoute";
import { ProjectObservabilityRoute } from "./routes/ProjectObservabilityRoute";
import { DeploymentDetailRoute } from "./routes/DeploymentDetailRoute";
import { AccountRoute } from "./routes/AccountRoute";
import { AdminRoute } from "./routes/AdminRoute";
import { DevAdminRoute } from "./routes/DevAdminRoute";
import { OperatorOpsRoute } from "./routes/OperatorOpsRoute";
import { DeviceAuthorizeRoute } from "./routes/DeviceAuthorizeRoute";
import { HealthRoute } from "./routes/HealthRoute";
import { NotFoundRoute } from "./routes/NotFoundRoute";
import { WhyRoute } from "./routes/WhyRoute";
import { ProjectInviteRoute } from "./routes/ProjectInviteRoute";

const SpaNavigationRegister = () => {
  const navigate = useNavigate();
  useEffect(() => {
    setSpaNavigate((to, opts) => {
      void navigate(to, { replace: Boolean(opts?.replace) });
    });
    return () => {
      setSpaNavigate(null);
    };
  }, [navigate]);
  return null;
};

export const App = () => (
  <AppErrorBoundary>
    <SpaNavigationRegister />
    <Routes>
      <Route path="/" element={<LandingRoute />} />
      <Route path="/why" element={<WhyRoute />} />
      <Route path="/login" element={<LoginRoute />} />
      <Route path="/admin" element={<DevAdminRoute />} />
      <Route path="/device" element={<DeviceAuthorizeRoute />} />
      <Route path="/home" element={<Navigate to="/dashboard" replace />} />
      <Route element={<WorkspaceLayout />}>
        <Route path="/dashboard" element={<DashboardRoute />} />
        <Route path="/projects" element={<ProjectsRoute />} />
        <Route path="/projects/new" element={<NewProjectRoute />} />
        <Route path="/projects/:id" element={<ProjectDetailRoute />} />
        <Route path="/projects/:id/settings" element={<ProjectSettingsRoute section="general" />} />
        <Route path="/projects/:id/settings/env" element={<ProjectSettingsRoute section="env" />} />
        <Route path="/projects/:id/settings/domains" element={<ProjectSettingsRoute section="domains" />} />
        <Route path="/projects/:id/settings/platform" element={<ProjectSettingsRoute section="platform" />} />
        <Route path="/projects/:id/settings/members" element={<ProjectSettingsRoute section="members" />} />
        <Route path="/projects/:id/settings/danger" element={<ProjectSettingsRoute section="danger" />} />
        <Route path="/projects/:id/observability" element={<ProjectObservabilityRoute />} />
        <Route path="/deployments/:id" element={<DeploymentDetailRoute />} />
        <Route path="/account" element={<AccountRoute />} />
        <Route path="/invites/:token" element={<ProjectInviteRoute />} />
        <Route path="/admin/examples" element={<AdminRoute />} />
        <Route path="/admin/ops" element={<OperatorOpsRoute />} />
        <Route path="/health" element={<HealthRoute />} />
      </Route>
      <Route path="*" element={<NotFoundRoute />} />
    </Routes>
  </AppErrorBoundary>
);
